package com.eladfinish.bible.contest

import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalTime::class)
val currentMilliseconds: Long
    get() = Clock.System.now().toEpochMilliseconds()
